export const PRIVACY_TERMS = `<div style="white-space: pre-wrap; padding: 10px;">
보이스파크 개인정보 처리방침

제1조(목적)

픽셀소프트웨어(이하 "회사") 의 파크골프 통합 플랫폼 서비스인 보이스파크 (이하 "서비스")는 이용자에게 원활한 파크골프 이용 서비스를 제공하기 위해 개인정보를 처리합니다. 본 개인정보처리방침은 이용자의 개인정보 보호와 관련하여 수집되는 정보의 내용 및 이용 방법을 알려드립니다.

제2조(수집하는 개인정보 항목)

사용자가 서비스에 가입하거나 서비스를 이용할 때, 서비스는 다음과 같은 개인 정보를 수집할 수 있습니다.
필수 입력 항목: 이름, 휴대전화번호, 생년월일, 성별, 본인인증 CI값
선택 사항: 선호 지역, 스코어

제3조(개인정보의 수집 및 이용 목적)
서비스는 수집한 개인정보를 다음의 목적을 위해 이용합니다.

1. 사용자 인증 및 등록 절차의 원활한 진행
2. 서비스 제공 및 관리(스코어, 공인 핸디 관리, 예약, 대회 접수 및 참가자 식별)
3. 서비스 개선 및 조사 분석 (사용자 경험 개선을 위한 통계 및 분석)
4. 고객 지원 및 서비스 관련 문의에 대한 응답
5. 법적 의무 준수(법률 등에 따른 요청)

제4조(개인정보의 보유 및 이용기간)
서비스는 개인정보 수집 목적이 달성될 때까지 개인정보를 보유하며, 이용자가 계정을 삭제하거나 서비스에서 탈퇴하는 경우 해당 정보를 즉시 파기합니다. 단, 법률에 따라 일정 기간 동안 정보를 보존해야 하는 경우에는 관련 법령에 따라 보존합니다.

제5조 (개인정보의 제3자 제공)
본 서비스는 이용자의 개인정보를 제3자에게 제공하지 않습니다. 다만, 다음의 경우에는 예외적으로 제공할 수 있습니다.

1. 이용자가 사전에 동의한 경우
2. 법률에 의한 요청이 있는 경우
3. 서비스 제공을 위하여 필요한 경우 제휴업체에 제공하는 경우 (이 경우 제공하는 정보는 최소화됩니다)

제6조(개인정보의 안전성 확보 조치)

본 서비스는 개인정보를 보호하기 위해 다음과 같은 보안 조치를 취하고 있습니다.
1. 개인정보의 저장 및 전송 암호화
2. 개인정보 접근권한 관리
3. 정기적인 보안 점검 및 취약점 관리

제7조(이용자의 권리)

1. 개인정보 접근: 이용자는 언제든지 자신의 개인정보에 접근할 수 있습니다.
2. 개인정보의 수정 및 삭제: 이용자는 자신의 개인정보를 수정하거나 삭제할 수 있습니다.
3. 이용 동의 철회: 이용자는 언제든지 서비스 이용 동의를 철회할 수 있습니다. 이 경우 서비스 제공이 제한될 수 있습니다.

제8조(개인정보처리방침의 변경)

본 서비스는 개인정보 처리방침을 변경할 수 있으며, 변경 사항은 서비스 내 공지사항을 통해 고지됩니다. 변경 사항은 공지일로부터 적용됩니다.

제9조(개인정보관리책임자)

개인정보와 관련하여 또는 제품과 관련하여 불만이나 의견이 있으신 분은 회사의 고객창구인 보이스파크 고객센터로 전화(02-523-5175) 주시거나 혹은 아래 개인정보보호책임자 또는 개인정보보호담당부서에게 의견을 주시면 즉시 조치하고 처리 결과를 통보해 드리겠습니다.

1) 개인정보보호책임자

- 성명 : 이충희
- 소속 : 픽셀소프트웨어
- 전화 : 02-523-5177
- 이메일 : dreamjr@fixelsoft.com

이용자는 회사의 서비스를 이용하시며 발생하는 모든 개인정보보호 관련 민원을 개인정보보호책임자 또는 회사에 신고하실 수 있습니다. 
회사는 이용자들의 신고사항에 대해 신속하게 충분한 답변을 드릴 것입니다. 
기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다.

2) 기타 기관
개인정보침해신고센터 ( privacy.kisa.or.kr / 국번없이 118)
대검찰청 과학수사부 사이버수사과 ( cybercid.spo.go.kr / 국번없이 1301)
경찰청 사이버안전지킴이 ( www.police.go.kr/www/security/cyber.jsp / 국번없이 182)

개인정보에 대한 동의
이용자는 서비스 이용 시 본 개인정보 처리방침에 명시된 사항에 동의함으로써 서비스가 개인정보를 수집, 이용 및 보관하는 것에 동의하는 것으로 간주합니다. 개인정보는 본 방침에 명시된 목적 이외의 용도로 이용되지 않으며, 이용자의 명시적인 동의 없이는 제3자에게 제공하지 않습니다.

동의 철회
이용자는 언제든지 제공된 개인정보 또는 사진 이용에 대한 동의를 철회할 수 있으며, 서비스 내 설정을 통해 개인정보 수정 또는 삭제를 요청할 수 있습니다. 동의를 철회할 경우 일부 서비스 이용에 제한이 있을 수 있습니다.

추가 조항
본 개인정보처리방침은 2025년 8월 25일부터 시행됩니다.
</div>`

export const SERVICE_TERMS = `<div style="white-space: pre-wrap; padding: 10px;">
서비스 이용약관

시행일자: 2025년 8월 25일

제1조 (목적)

본 약관은 픽셀소프트웨어가 제공하는 보이스파크 서비스(이하 "서비스")의 이용과 관련하여 회사와 이용자 간의 권리, 의무 및 책임 사항을 규정함을 목적으로 합니다.

제2조 (용어의 정의)

서비스: 회사가 운영하는 모바일 앱, 웹 을 통해 제공하는 파크골프 대회 접수, 예약, 결제, 경기 정보, 스코어 확인 등의 기능
회원: 본 약관에 동의하고 서비스 이용 계약을 체결한 자
비회원: 회원 가입 없이 일부 서비스만 이용하는 자
대회: 회사 또는 제휴 단체가 주최·주관하는 파크골프 경기
예약: 대회 참가를 위해 일정, 인원, 결제 등을 확정하는 행위

제3조 (약관의 효력 및 변경)
본 약관은 회원이 가입 시 동의함으로써 효력이 발생합니다.
회사는 필요한 경우 관련 법령을 위배하지 않는 범위에서 약관을 변경할 수 있으며, 변경 시 최소 7일 전 앱 및 홈페이지에 공지합니다.
회원이 변경된 약관에 동의하지 않을 경우 서비스 이용을 중단하고 회원 탈퇴를 요청할 수 있습니다.


제4조 (회원 가입 및 계정 관리)

회원 가입은 이용자가 약관 및 개인정보 처리방침에 동의하고, 회사가 정한 절차를 완료한 후 승인함으로써 성립합니다.
회원은 계정 정보를 정확하게 입력해야 하며, 허위 정보로 인한 불이익은 본인에게 있습니다.
회원 계정은 본인만 사용 가능하며, 타인에게 양도·대여할 수 없습니다.

제5조 (서비스의 제공 및 변경)

회사는 회원에게 다음과 같은 서비스를 제공합니다.
파크골프 예약 서비스 이용
파크골프 대회 접수 및 참가 신청
대회 참가비 결제
경기 일정, 장소, 결과 안내
대회 관련 공지 및 알림
스코어 확인
회사는 서비스 내용이나 운영 방식을 변경할 수 있으며, 중요한 변경 시 사전에 공지합니다.

제6조 (예약 및 결제)

회원은 서비스 내에서 대회 예약 및 결제를 할 수 있습니다.
결제 완료 시 예약 확정이 이루어지며, 예약금 환불은 제7조에 따릅니다.
대회 참가비 결제는 접수 이후 확정시 이루어지며,
대회 주최 측이 정한 기준에 따라 환불 규정이 적용됩니다.

제7조 (취소 및 환불 규정)

회원이 예약을 취소할 경우, 환불 규정은 다음과 같습니다.
라운딩 시작 7일 전까지 취소: 전액 환불
라운딩 시작 3일 전까지 취소: 50% 환불
라운딩 시작 3일 이내 취소: 환불 불가
천재지변, 주최 측 사정 등으로 대회가 취소되는 경우 전액 환불합니다.

제8조 (회원의 의무)

회원은 다음 행위를 해서는 안 됩니다.
타인의 계정 도용
허위 정보 등록
대회 진행 방해 또는 규칙 위반
법령이나 사회질서에 반하는 행위
위반 시 회사는 경고, 서비스 이용 제한, 계정 삭제 등의 조치를 취할 수 있습니다.

제9조 (회사의 의무)

회사는 안정적인 서비스 제공을 위해 최선을 다합니다.
회사는 회원의 개인정보를 관련 법령에 따라 보호하며, 동의 없이 제3자에게 제공하지 않습니다.


제10조 (저작권 및 지식재산권)

서비스에 게시된 콘텐츠의 저작권은 회사 또는 해당 권리자에게 귀속됩니다.
회원은 회사의 사전 승인 없이 이를 복제, 배포, 수정, 판매할 수 없습니다.

제11조 (서비스 이용 제한 및 계약 해지)

회사는 회원이 약관을 위반한 경우 사전 통보 후 서비스 이용을 제한하거나 계약을 해지할 수 있습니다.
회원은 언제든 앱 내 설정을 통해 탈퇴할 수 있습니다.

제12조 (면책 조항)

회사는 다음 사유로 발생한 손해에 대해 책임을 지지 않습니다.
회원의 고의 또는 과실로 인한 손해
통신망 장애, 시스템 오류 등 불가항력적 사유
대회 주최 측 사정으로 인한 변경·취소
회사는 회원 간 또는 회원과 제3자 간에 발생한 분쟁에 개입하지 않습니다.

제13조 (분쟁 해결)

본 약관에 명시되지 않은 사항은 관련 법령과 상관례에 따릅니다.
서비스 이용과 관련하여 발생한 분쟁은 회사 소재지 관할 법원을 전속 관할로 합니다.
</div>`